var map = {
	"./addNewSurveyForm.png": 4153,
	"./adminDashboard.png": 7008,
	"./companyList.png": 2135,
	"./dashboard.png": 530,
	"./formBuilder.png": 6704,
	"./login.png": 4658,
	"./subActivityList.png": 193,
	"./subActivityReporting.png": 7772,
	"./userList.png": 8865
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2345;